import 'index.css';

import App from 'App';
import { Buffer } from 'buffer';
import { AppProviders } from 'context';
import React from 'react';
import ReactDOM from 'react-dom/client';

window.Buffer = window.Buffer || Buffer;

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </React.StrictMode>,
);
